import { Component, Host, Prop, h } from '@stencil/core';
import state from '@ugc-store';
import { defaultReview, IReview } from '@ugc-components/ugc-pdp-review/interface';
import { FontType, isRtl } from '@ugc-utils/utils';
import { ReportAbuseType } from '@ugc-containers/ugc-report-abuse/interfaces';
import { modalZIndex } from '@ugc-utils/modal-z-index';
import { More } from '../../../icons';

@Component({
  tag: 'ugc-review-operate',
  shadow: false,
})
export class UgcReviewOperate {
  @Prop() reviewItem: IReview = defaultReview;
  @Prop() isModal?: boolean = false;

  openModal = () => {
    state.isShowSwitchLanguageModal = true;
    state.switchLanguageModal = {
      reviewItem: this.reviewItem,
      isModal: this.isModal,
    };
  };

  render() {
    const { isDesktop } = state;
    const { id, shareUrl } = this.reviewItem;
    const isLargeType = isDesktop && !this.isModal;
    const fontType = isLargeType ? FontType.large : FontType.small;
    const shareWidgetPositionInModal = isRtl() ? 'right' : 'left';
    if (isDesktop)
      return (
        <Host class={`flex-row-start-center ${isLargeType && 'gap-8'}`}>
          <ugc-report-abuse
            type={ReportAbuseType.Review}
            referenceId={id}
            fontType={fontType}
            data-testid="pdp-review-report-abuse"
          />
          <span class="lh-16">
            <ugc-share
              shareWidgetLayer={this.isModal && modalZIndex['share-widget-layer']}
              sid={`${isLargeType}-${this.isModal}-${id}`}
              shareUrl={shareUrl}
              position={this.isModal ? shareWidgetPositionInModal : 'bottom'}
              gaEvent={{
                'data-ga-event-name': 'open_share_widget',
                'data-ga-content-type': 'review',
                'data-ga-location-detail': 'pdp review',
              }}
              fontType={fontType}
              data-testid="pdp-review-share"
            />
          </span>
        </Host>
      );

    return (
      <Host onClick={this.openModal} class="p-2">
        <More />
      </Host>
    );
  }
}
